import { Alert } from '@vtex/shoreline'

import Loading from '~/components/Loading'
import { getAccountInfo } from '~/helpers/account-info'
import { useAppInfo } from '~/hooks/useAppInfo'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'
import AdListFilters from '~/modules/retailMedia/components/_tables/AdListFilters'
import AdsTable from '~/modules/retailMedia/components/_tables/AdsTable'
import CampaignAdditionalKeywordsTable from '~/modules/retailMedia/components/_tables/CampaignAdditionalKeywordsTable'
import CampaignPlacementsTable from '~/modules/retailMedia/components/_tables/CampaignPlacementsTable'
import AudiencePanel from '~/modules/retailMedia/components/AudiencePanel'
import Budget from '~/modules/retailMedia/components/Budget'
import { CampaignInsertionOrderPanel } from '~/modules/retailMedia/components/CampaignInsertionOrderPanel'
import CampaignSubpublishers from '~/modules/retailMedia/components/CampaignSubpublishers'
import DailyHistoryTable from '~/modules/retailMedia/components/DailyHistoryTable'
import { InfoView } from '~/modules/retailMedia/components/InfoView'
import { ObjectiveBasedCampaignHeader } from '~/modules/retailMedia/components/ObjectiveBased/CampaignHeader'
import { StatusBar } from '~/modules/retailMedia/components/StatusBar'
import StatusHistory from '~/modules/retailMedia/components/StatusHistory'

import MetricsCampaignView from '../Metrics'

const ViewProductCampaign: React.FC<ViewCampaignProps> = ({
  data,
  loading
}) => {
  const { t } = useAPPTranslation()
  const { superAdmin } = useAppInfo()

  const hasPlacements = !!data.settings?.has_placements
  const hasAudience = !!data.audienceId
  const isSeller = !!getAccountInfo()?.sellerId
  const isObjectiveBasedStrategy =
    data?.raw?.strategy_type === 'objective_based'

  return (
    <>
      {isObjectiveBasedStrategy ? (
        <ObjectiveBasedCampaignHeader data={data} />
      ) : (
        <AdListFilters adType={data?.adType} />
      )}

      <MetricsCampaignView
        adType={data?.adType}
        strategy={data?.raw?.strategy_type}
      />

      <Loading status={loading}>Carregando dados das campanhas...</Loading>

      {isSeller && (
        <section className="mb-2">
          <Alert variant="informational">{t('rm:alert.seller.buyBox')}</Alert>
        </section>
      )}

      <AdsTable
        campaignAdType={data?.adType}
        strategy={data?.raw?.strategy_type}
      />

      <hr />

      <DailyHistoryTable
        campaignType={data?.adType}
        campaignStartDate={data?.raw?.start_at}
      />

      {!!superAdmin && (
        <>
          <hr />
          <CampaignAdditionalKeywordsTable campaignId={data.id} />
        </>
      )}

      {!isObjectiveBasedStrategy && (
        <>
          <hr />
          <Budget data={data} loading={loading} />
          <CampaignInsertionOrderPanel
            campaignId={data.id}
            insertionOrders={data.insertionOrders}
          />
          {hasAudience && <AudiencePanel audienceId={data?.audienceId} />}
          {hasPlacements && (
            <>
              <hr />
              <CampaignPlacementsTable campaignId={data?.id} />
            </>
          )}
          <InfoView data={data} />
        </>
      )}
      {isObjectiveBasedStrategy && (
        <CampaignInsertionOrderPanel
          campaignId={data.id}
          insertionOrders={data.insertionOrders}
        />
      )}

      <CampaignSubpublishers
        publisherId={data.publisher.id}
        campaignData={data}
      />

      <StatusBar
        status={data?.status}
        message={
          data?.status_history?.length > 0 ? data?.status_history[0]?.note : ''
        }
      />

      <StatusHistory data={data?.status_history} />
    </>
  )
}

export default ViewProductCampaign
